import React from "react";
const TextField = (props: any) => {
  const { placeholder, value, register, type = "text", errors, label } = props;
  return (
    <>
      <div className="w-full my-2 text-left mt-4">
        <label htmlFor="">{label}</label>
        <input
          placeholder={placeholder}
          defaultValue={value}
          {...register}
          type={type}
          className="w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1"
        />
        {errors && (
          <p className="text-red-500 text-xs my-1">{errors?.message}</p>
        )}
      </div>
    </>
  );
};

export default TextField;
